if (!customElements.get('willian-product-tabs')) {
  customElements.define(
    'willian-product-tabs',
    class WillianProductTabs extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.activateTab(tab));
          tab.addEventListener('keydown', (event) => this.handleKeydown(event));
        });

        this.setupResponsivePlacement();
      }

      setupResponsivePlacement() {
        this.layoutWrapper = this.closest('.product__details-wrapper');
        this.productRoot = this.closest('.product');
        this.infoContainer = this.productRoot?.querySelector('.product__info-container');

        if (!this.layoutWrapper || !this.productRoot || !this.infoContainer) return;

        this.desktopPlaceholder = document.createComment('willian-product-tabs-desktop-position');
        this.layoutWrapper.parentNode.insertBefore(this.desktopPlaceholder, this.layoutWrapper);

        this.mobileMediaQuery = window.matchMedia('(max-width: 749px)');
        this.updatePlacement = () => {
          if (this.mobileMediaQuery.matches) {
            const firstSupportBlock = this.infoContainer.querySelector('.product__accordion, share-button');

            if (firstSupportBlock) {
              this.infoContainer.insertBefore(this.layoutWrapper, firstSupportBlock);
            } else {
              this.infoContainer.appendChild(this.layoutWrapper);
            }

            this.layoutWrapper.classList.add('product__details-wrapper--mobile');
          } else if (this.desktopPlaceholder.parentNode) {
            this.desktopPlaceholder.parentNode.insertBefore(
              this.layoutWrapper,
              this.desktopPlaceholder.nextSibling
            );
            this.layoutWrapper.classList.remove('product__details-wrapper--mobile');
          }
        };

        this.mobileMediaQuery.addEventListener('change', this.updatePlacement);
        this.updatePlacement();
      }

      activateTab(nextTab) {
        const target = nextTab.dataset.tab;

        this.tabs.forEach((tab) => {
          const isActive = tab === nextTab;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.tabIndex = isActive ? 0 : -1;
        });

        this.panels.forEach((panel) => {
          const isActive = panel.dataset.panel === target;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
      }

      handleKeydown(event) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

        event.preventDefault();
        const currentIndex = this.tabs.indexOf(event.currentTarget);
        let nextIndex = currentIndex;

        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;

        this.tabs[nextIndex].focus();
        this.activateTab(this.tabs[nextIndex]);
      }
    }
  );
}
